import crm from "./crm";

const ticketConclusaoTipoService = {
  index: () => {
    return crm.get("/ticket-conclusao-tipo");
  },
  store: (dados) => {
    let uri = `/ticket-conclusao-tipo`;
    return crm["post"].call(crm, uri, dados);
  },
  show: (idTicket) => {
    let uri = `/ticket-conclusao-tipo/${idTicket}`;
    return crm["get"].call(crm, uri);
  },
  update: (dados, idTicket) => {
    let uri = `/ticket-conclusao-tipo/${idTicket}`;
    return crm["put"].call(crm, uri, dados);
  },
  delete: (idTicket) => {
    let uri = `/ticket-conclusao-tipo/${idTicket}`;
    return crm["delete"].call(crm, uri);
  },
};

export default ticketConclusaoTipoService;
